import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';
import { pisCofinsCstData } from '../TaxeCofinsCstSelect';

const TaxePisCstSelect = forwardRef<BaseSelectRef, SelectProps>(
  (props, ref) => {
    return (
      <Select
        {...props}
        showSearch
        optionFilterProp="label"
        ref={ref}
        options={pisCofinsCstData}
      />
    );
  },
);

export default TaxePisCstSelect;
